<!-- Создаёт или редактирует один автопарк. -->
<template>
  <BaseModal
    :visible="visible"
    :title="modalTitle"
    size="md"
    footer-align="start"
    elevated-footer
    @close="close"
  >
    <FleetParkForm
      :id="formId"
      :fleet-park="fleetPark"
      @submit="handleSubmit"
    />

    <template #footer>
      <base-primary-button
        type="submit"
        :form="formId"
        :disabled="isSubmitting"
      >
        <span v-if="isSubmitting">Сохранение...</span>
        <span v-else>Сохранить</span>
      </base-primary-button>
      <base-button type="button" :disabled="isSubmitting" @click="close">
        Отмена
      </base-button>
    </template>
  </BaseModal>
</template>

<script>
import FleetParkForm from "@/components/Fleet/Park/Form.vue";
import { useFleetParkStore } from "@/stores/fleetParkStore";

export default {
  name: "FleetParkModal",

  components: {
    FleetParkForm,
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    fleetPark: {
      type: Object,
      default: null,
    },
  },

  emits: ["close", "created", "updated", "saved"],

  computed: {
    fleetParkStore() {
      return useFleetParkStore();
    },

    editMode() {
      return Boolean(this.fleetPark?.id);
    },

    modalTitle() {
      return this.editMode ? "Редактировать автопарк" : "Новый автопарк";
    },

    formId() {
      return this.editMode
        ? `fleet-park-edit-form-${this.fleetPark.id}`
        : "fleet-park-create-form";
    },

    isSubmitting() {
      return this.fleetParkStore.isSubmitting;
    },
  },

  methods: {
    async handleSubmit(formData) {
      const payload = this.buildPayload(formData);
      const fleetPark = this.editMode
        ? await this.updateFleetPark(payload)
        : await this.createFleetPark(payload);

      this.$emit("saved", fleetPark);
      this.close();
    },

    buildPayload(formData) {
      return {
        name: formData.name,
        daily_target_km: Number(formData.daily_target_km),
      };
    },

    async createFleetPark(payload) {
      const fleetPark = await this.fleetParkStore.createFleetPark(payload);
      this.$emit("created", fleetPark);

      return fleetPark;
    },

    async updateFleetPark(payload) {
      const fleetPark = await this.fleetParkStore.updateFleetPark(
        this.fleetPark.id,
        payload
      );
      this.$emit("updated", fleetPark);

      return fleetPark;
    },

    close() {
      this.$emit("close");
    },
  },
};
</script>
